import { useDispatch } from 'react-redux';
import { submitMokaConfigEditForm } from 'state/mokaConfig/actions';
import {
  Form,
  FormField,
  Button,
  Segment,
  Divider,
  Grid,
} from 'semantic-ui-react';
import { Field, Form as FinalForm } from 'react-final-form';
import { FieldArray } from 'react-final-form-arrays';
import arrayMutators from 'final-form-arrays';
import React from 'react';
import ValidatedFormInput from 'components/ValidatedFormInput';

function MokaConfigForm(configData) {
  const dispatch = useDispatch();
  const { data: initialData } = configData;

  const mokaData = initialData.prices.filter(price => price.id === 1);
  const priceData = initialData.prices.filter(price => price.id !== 1);

  const initValue = {
    moka: mokaData,
    prices: priceData,
    discounts: initialData.discounts,
  };

  const onConfigSubmit = values => {
    dispatch(submitMokaConfigEditForm(values));
  };

  const priceValidation = value => {
    const isNumber = !Number.isNaN(Number(value));
    if (typeof value === 'undefined') {
      return 'Required';
    }
    if (!isNumber || value < 0) {
      return 'Wrong price format';
    }
    return undefined;
  };

  const discountValidation = value => {
    const isNumber = !Number.isNaN(Number(value));
    if (typeof value === 'undefined') {
      return 'Required';
    }
    if (!isNumber || value < 0 || value > 100) {
      return 'Discount must be between 0-100';
    }
    return undefined;
  };

  return (
    <div style={{ marginTop: 12 }}>
      <FinalForm
        onSubmit={onConfigSubmit}
        initialValues={initValue}
        mutators={{
          ...arrayMutators,
        }}
        render={({ handleSubmit }) => (
          <Form onSubmit={handleSubmit}>
            <Grid>
              <Grid.Row columns={2}>
                <Grid.Column width={6}>
                  <Segment>
                    <h3>Feature Subscription</h3>
                    <Divider />
                    <FieldArray name="prices">
                      {({ fields }) =>
                        fields.map((price, index) => (
                          <FormField key={price}>
                            <label>
                              {fields.value[index].feature_display_name} (Rp)
                            </label>
                            <Field
                              data-testid={
                                fields.value[index].feature_display_name
                              }
                              name={`${price}.price_per_month`}
                              component={ValidatedFormInput}
                              validate={priceValidation}
                            />
                          </FormField>
                        ))
                      }
                    </FieldArray>
                  </Segment>
                </Grid.Column>
                <Grid.Column width={6}>
                  <Segment>
                    <h3>Discount</h3>
                    <Divider />
                    <FieldArray name="discounts">
                      {({ fields }) =>
                        fields.map((price, index) => (
                          <FormField key={price}>
                            <label>{fields.value[index].name} </label>
                            <Field
                              name={`${price}.discount`}
                              type="text"
                              component={ValidatedFormInput}
                              validate={discountValidation}
                            />
                          </FormField>
                        ))
                      }
                    </FieldArray>
                  </Segment>
                  <Button type="submit">Submit</Button>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Form>
        )}
      />
    </div>
  );
}

export default MokaConfigForm;
